<template>
    <div class="section-label">
        <div class="label">
            <div class="section-no">SECTION {{ sectionNo }}</div>
            <div class="section-name">{{ label }}</div>
        </div>  
        <div class="title">{{ title }}</div>                       
    </div>
</template>

<script>
export default {
    name: 'SectionLabel',
    props: ['label', 'title', 'sectionNo']
}
</script>

<style scoped 
       lang="scss">
    @import "../../static/styles/palette.scss";

    .section-label {
        position: relative;
        width: 520px;
        z-index: 10;
        left: -12px;

        & .label {
            display: flex;
            align-items: center;
            width: 280px;
            height: 40px;
            background-color: $darkGray;
            color: white;
            padding: 0 26px;

            & .section-no {
                font-family: "Roboto";
                font-style: italic;
                font-stretch: condensed;
                letter-spacing: 2px;
                margin-right: 20px;
            }

            & .section-name {
                font-weight: bold;
                letter-spacing: 4px;
            }
        }        

        & .title {
            position: relative;
            font-size: 65px;
            font-family: "Fugaz One";   
            font-weight: bold;
            text-shadow: 4px 5px 0 white;
            color: $darkGray;
            letter-spacing: 5px;
            margin: 40px 0 0 80px;
        }
    }

    @media all and (max-width: 768px){
        .section-label {
            width: 400px;

            & .title {
                margin: 30px 0 0 50px;
                font-size: 50px;
            }
        }
    }

    @media all and (max-width: 480px){
        .section-label {
            width: 300px;

            & .label {
                width: 240px;
                font-size: 13px;
                padding: 0 15px;
                height: 35px;
            }
            
            & .title {
                margin: 20px 0 0 40px;
                font-size: 36px;
            }
        }
    }

    @media all and (max-width: 320px){
        .section-label {
            width: 300px;
            
            & .title {
                margin: 20px 0 0 30px;
                font-size: 32px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// SectionLabel.vue?fcb5b1fe